module.exports = __webpack_public_path__ + "img/jsbzm.20b961b2.png";